export default __webpack_public_path__ + "5f015c7e729dfddbd0761e7a104c3c08.png";